import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button } from 'antd'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input

@inject('emailAddressStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
    const {emailAddressStore, title} = this.props
    const {detailsObj, searchItem} = emailAddressStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'marketGroupId': searchItem?.marketGroupId,
        "subject": detailsObj?.subject,
        "description": detailsObj?.description,
      })
    }
  }
  handleOk = () => {
    const {emailAddressStore, handleCancel, title} = this.props
    const {detailsObj} = emailAddressStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "marketGroupId": fieldsValue?.marketGroupId,
        "subject": fieldsValue?.subject,
        "description": fieldsValue?.description,
      }
      if (title === 'edit') {
        emailAddressStore.onEditJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        emailAddressStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const { emailAddressStore, addModalVisible, handleCancel, title, t } = this.props
    const { groupList } = emailAddressStore
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`emailSend.editAddress`) : t(`emailSend.addAddress`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item name="marketGroupId" label={t(`emailSend.marketingGroup`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.marketingGroup`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } disabled={title==='edit'}>
                    {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="subject" label={t(`emailSend.className`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`emailSend.className`)}`,
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="description" label={t(`emailSend.remark`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)} ${t(`emailSend.remark`)}`,
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="groupName" label={t(`emailSend.subscriptionPluginCode`)} rules={[{
                  required: false,
                  message: `${t(`general.pleaseEnter`)} ${t(`emailSend.subscriptionPluginCode`)}`,
                }]}>
                  <TextArea rows={10} 
                    placeholder='                <iframe allowtransparency="true" frameborder="0" width="320" height="107" scrolling="no" src="https://www.bestedm.net/address/subscribe/add/?id=610,2365024"></iframe>
                    
                英文订阅页面:
                <iframe allowtransparency="true" frameborder="0" width="320" height="107" scrolling="no" src="https://www.bestedm.net/address/subscribe/add/?id=610,2365024&language=en"></iframe>' 
                  style={{width: '100%'}} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
